module.exports = "\n/**\n * We're almost done.\n */\n\n pre:hover{\n   box-shadow: 0px 0px 40px 5px rgba(255,255,255,0.4);\n }\n\n #skip-animation, #pause-resume {\n   display: none;\n }\n\n/**\n * I hope you enjoyed this.\n *\n * Thanks to Jake Albaugh and Jacky, for the input ,ideas and reviews.\n\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./styles3.css
 ** module id = 89
 ** module chunks = 0 1
 **/